import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { EndTimeFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useEndTimeFilter = (model: EndTimeFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<EndTimeFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: EndTimeFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        afterEndDate: newModel?.type === 'greaterThan',
        endDate: newModel?.endDate || undefined,
        endDateTo: newModel?.endDateTo || undefined,
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const hasModelChanged =
      JSON.stringify(model) !== JSON.stringify(previousModelReference.current);

    if (hasModelChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};
